import script from "./xtx-checkbox.vue?vue&type=script&setup=true&lang=js"
export * from "./xtx-checkbox.vue?vue&type=script&setup=true&lang=js"

import "./xtx-checkbox.vue?vue&type=style&index=0&id=01658699&lang=less&scoped=true"

import exportComponent from "D:\\hbuilderxpro\\jxshop\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01658699"]])

export default __exports__